import React, {
  useContext,
  useCallback,
  useEffect,
  useState,
} from "react";
import useEmblaCarousel from "embla-carousel-react";
import GalleryCard from "./GalleryCard";
import { getData } from "../../lib/utils";
import { Context } from "../../components/contexts/AppContext";

const GallerySection = () => {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;

  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(false);

  const selectedVideos =
    appState?.currentGalleryData?.selectedVideos || [];

  const galleryData = selectedVideos
    .map((id) =>
      appState.videoArr.find((video) => video._id === id)
    )
    .filter(Boolean);

  // =========================================
  // EMBLA DESKTOP ONLY
  // =========================================
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    align: "start",
    speed: 8,
    dragFree: false,
    containScroll: "trimSnaps",
  });

  const updateButtons = useCallback(() => {
    if (!emblaApi) return;

    setCanPrev(emblaApi.canScrollPrev());
    setCanNext(emblaApi.canScrollNext());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;

    updateButtons();

    emblaApi.on("select", updateButtons);
    emblaApi.on("reInit", updateButtons);

    return () => {
      emblaApi.off("select", updateButtons);
      emblaApi.off("reInit", updateButtons);
    };
  }, [emblaApi, updateButtons]);

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  // =========================================
  // PLAY VIDEO
  // =========================================
const handlePlay = async (item) => {

  
 window.history.pushState(
  { type: "videoPlayer" },
  ""
);

  window.dispatchEvent(new Event("STOP_BACKGROUND_AUDIO"));

  const data = await getData(
    `chapters/getChaptersByVideo/${item._id}`
  );

  if (data) {

    console.log("--------data ",data)
    setAppState((prevState) => ({
      ...prevState,
      currentChapterArr: data,
      currentVideoUrl: item.url,
      currentVideoId: item._id,
      modalData: {
        ...prevState.modalData,
        type: "ChapterListModal",
        isOpen: true,
        isPlayAll: false,
      },
    }));
  }
};
  return (
    <div className="relative w-full py-6">

      {/* ===================================== */}
      {/* MOBILE VIEW */}
      {/* ===================================== */}
      <div className="flex flex-col gap-4 px-4 md:hidden">
        {galleryData.map((item, index) => (
          <div key={index} className="w-full">
            <GalleryCard
              image={item.image}
              title={item.title}
              item={item}
              videoid={item._id}
              onPlay={() => handlePlay(item)}
            />
          </div>
        ))}
      </div>

      {/* ===================================== */}
      {/* DESKTOP VIEW */}
      {/* ===================================== */}
      <div className="hidden md:block relative">

        {/* LEFT BUTTON */}
        {canPrev && (
          <button
            onClick={scrollPrev}
            className="
              absolute left-0 top-0 bottom-0 z-20
              w-24
              bg-gradient-to-r from-black/0 to-transparent
              text-white text-[130px]
              flex items-center justify-center
              transition-all duration-300
            "
          >
            ‹
          </button>
        )}

        {/* RIGHT BUTTON */}
        {canNext && (
          <button
            onClick={scrollNext}
            className="
              absolute right-0 top-0 bottom-0 z-20
              w-24
              bg-gradient-to-l from-black/0 to-transparent
              text-white text-[130px]
              flex items-center justify-center
              transition-all duration-300
            "
          >
            ›
          </button>
        )}

        {/* SLIDER */}
        <div className="overflow-hidden px-10" ref={emblaRef}>
          <div className="flex gap-4">
            {galleryData.map((item, index) => (
              <div
                key={index}
                className="min-w-[320px] flex-[0_0_auto]"
              >
                <GalleryCard
                  image={item.image}
                  title={item.title}
                  item={item}
                  videoid={item._id}
                  onPlay={() => handlePlay(item)}
                />
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default GallerySection;